/* The trainer's links: a discreet row of small monochrome icons. Neutral ink, never the accent — the
 * accent marks the page's one action, and a link row is not it. */

.links {
  position: relative;
  z-index: 6;
}

.list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
  align-items: center;
  justify-content: center;
  padding: var(--space-0);
  margin: var(--space-0);
  list-style: none;
}

.link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--studio-link-size);
  height: var(--studio-link-size);
  color: var(--studio-ink-muted);
  border-radius: var(--r-circle);
  transition-property: color, background-color;
  transition-duration: var(--dur-fast);
  transition-timing-function: var(--ease);
}

.link:hover {
  color: var(--studio-ink);
  background: var(--studio-surface-hover);
}

.link:focus-visible {
  color: var(--studio-ink);
  outline: var(--border-focus) solid var(--studio-ink);
  outline-offset: var(--studio-focus-offset);
}

.glyph {
  display: block;
  width: var(--studio-link-icon);
  height: var(--studio-link-icon);
}
